module.exports = __webpack_public_path__ + "static/media/logo_ministere_education_2021.1322c582.jpg";